import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
};

export const schemaUserResolver_GetRole = UsersTableDefinitionZod.shape.role.nullable();

export type SchemaUserResolver_GetRole = z.infer<typeof schemaUserResolver_GetRole>;

export type UserResolver_GetRole = Resolver<Arguments, SchemaUserResolver_GetRole>;
